export const isWidthXs = width => width === 'xs';
export const isWidthSm = width => width === 'sm';
export const isWidthFs = width => width === 'fs';
export const isWidthMd = width => width === 'md';
export const isWidthSmDown = width => (isWidthXs(width) || isWidthSm(width));
export const isWidthFsDown = width => (isWidthXs(width) || isWidthSm(width) || isWidthMd(width) || isWidthFs(width));
export const isHideFilters = width => ((isWidthXs(width) || isWidthSm(width) || isWidthMd(width)));
